import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const add_proxy = (
  proxyHost,
  proxyPort,
  proxyUsername,
  proxyPassword,
  proxyType,
  status
) => {
  return api.post(`${ApiEndpointConstants.ADDPROXY}`, {
    proxyHost,
    proxyPort,
    proxyUsername,
    proxyPassword,
    proxyType,
    status,
  });
};
